/* Only prepares native searches. Liquid always checks each returned resource. */
(() => {
  const config = document.querySelector('[data-cx-site-query]');
  if (!config) return;
  const clause = config.dataset.cxSiteQuery;
  const clean = value => String(value || '').replace(/^tag:"site_scope:cbd" OR tag:"site_scope:both"\s*/, '').replace(/^-tag:"site_scope:cbd"\s*/, '').trim();
  const query = value => {
    const term = clean(value).replace(/[():\\"]/g,' ').replace(/\b(?:AND|OR|NOT)\b/g,' ').trim();
    return clause + (term ? ' ' + term : '');
  };
  window.CXSite = Object.freeze({query, clean});
  const current = new URL(location.href);
  if (current.pathname.replace(/\/$/,'').endsWith('/search') && !current.searchParams.has('section_id') && !current.searchParams.has('sections')) {
    const next = query(current.searchParams.get('q'));
    if (current.searchParams.get('q') !== next || current.searchParams.get('type') !== 'product') {
      current.searchParams.set('q',next); current.searchParams.set('type','product');
      current.searchParams.delete('page'); location.replace(current.href); return;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action,location.href).pathname.endsWith('/search')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const url = new URL(form.action,location.href), data = new FormData(form);
    for (const [key,value] of data) url.searchParams.set(key,String(value));
    url.searchParams.set('q',query(data.get('q'))); url.searchParams.set('type','product');
    location.assign(url.href);
  },true);
})();
